<template>
  <div class="cad">
    <span class="cad-icon"></span>
    <span class="cad-title">
      {{ data.title }}
      <small class="cad-description">{{ data.description }}</small>
    </span>
    <span class="cad-quantity">{{ data.quantity }}</span>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/sass/variables';

  .cad {
    background: #000;
    margin-bottom: 1px !important;
    padding: 10px 15px;

    display: flex;
    justify-content: flex-start;
  }

  .cad-icon {
    background: $cadIcon no-repeat center left;
    width: 32px;

  }

  .cad-title {
    color: #fff;
    font-size: 18px;
    display: block;
    line-height: 1.25;
  }

  .cad-description {
    color: #666;
    font-size: 13px;
    display: block;
  }

  .cad-quantity  {
    color: #00A800;
    font-size: 24px;
    font-weight: bold;
    margin-left: auto;

    @each $city, $map in $cities {
      .is-#{$city} & {
        color: map-get($map, 'primary');
      }            
    }
  }

</style>
